import { WsEvent } from '@ts-ws/enums'

import { useCustomerStore } from '@stores/me/customer'
import { useDisciplineStore } from '@stores/discipline'
import { useProgressReportStore } from '@stores/progress-report'

import { useProgressReportsListApi } from '@api/disciplines/progress-reports/list.hook'
import { useActiveDisciplineInfoApi } from '@api/disciplines/active-discipline-info.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'
import { useKidRoutes } from '@composables/routes/kid-route.hook'

export const useListenEventProgressReport = (channel: any): void => {
  const customerStore = useCustomerStore()
  const disciplineStore = useDisciplineStore()
  const progressReportsStore = useProgressReportStore()

  const {
    isRouteProgressReports,
  } = useKidRoutes()

  onDisciplineReady(() => {
    if (customerStore.isActiveDisciplinePaid && !disciplineStore.isActivation) {
      channel.listen(WsEvent.ProgressReportCreated, async (): Promise<void> => {
        const disciplineId = disciplineStore.activeDiscipline?.id
        if (!disciplineId) return

        if (isRouteProgressReports.value) {
          const listMode = progressReportsStore.getListStatus(disciplineId) === 'ready' ? 'refresh' : 'enter'
          void useProgressReportsListApi().getProgressReportList(disciplineId, listMode)
        } else {
          progressReportsStore.setNewProgressReport(disciplineId, true)
          void useActiveDisciplineInfoApi({ disciplineId, mode: 'refresh' })
        }
      })
    }
  })
}
